import React from 'react';
// import AuthGateContainer from '@bvt-features/auth/container/AuthGateContainer';
import { BasePageHeadTag } from '@bvt-shared/component/BasePageHeadTag';
import { LayoutMainMapContainer } from '@bvt-features/mainmap/mainmap/container/LayoutMainMapContainer';
import Page from '../../../pages/bvt';
import { Outlet } from 'react-router-dom';
/** @type {import('react-router').RouteObject} */
export const RoutesAppMap = {
  path: 'map',
  element: (
    <React.Fragment>
      <LayoutMainMapContainer>
        <BasePageHeadTag title='LI :: Map' />
        <Outlet />
      </LayoutMainMapContainer>
    </React.Fragment>
  ),
  children: [
    {
      index: true,
    },
    {
      path: 'map-analytic',
      element: (
        <React.Fragment>
          <BasePageHeadTag title='LI :: Map Analytics' />
          <Page.Mapana />
        </React.Fragment>
      ),
      children: [
        {
          path: 'grid-analysis',
          element: (
            <React.Fragment>
              <BasePageHeadTag title='LI :: Map Analytics :: Grid Analysis' />
              <Page.CreateEditGridAnalysis />
            </React.Fragment>
          ),
        },
      ],
    },
    {
      path: 'map-analytic',
      element: (
        <React.Fragment>
          <BasePageHeadTag title='LI :: Map Analytics' />
          <Page.Mapana />
        </React.Fragment>
      ),
      children: [
        {
          path: 'grid-analysis-lawu',
          element: (
            <React.Fragment>
              <BasePageHeadTag title='LI :: Map Analytics :: Grid Analysis Lawu' />
              <Page.CreateEditGridAnalysisLawu />
            </React.Fragment>
          ),
        },
      ],
    },
    {
      path: 'map-analytic',
      children: [
        {
          path: 'site-profiling',
          element: (
            <React.Fragment>
              <BasePageHeadTag title='LI :: Map Analytics :: Site Profiling' />
              <Page.CreateEditSiteProfiling />
            </React.Fragment>
          ),
        },
      ],
    },
    {
      path: 'map-analytic',
      children: [
        {
          path: 'site-profiling-mandala',
          element: (
            <React.Fragment>
              <BasePageHeadTag title='LI :: Map Analytics :: Site Profiling Mandala' />
              <Page.CreateEditSiteProfilingMandala />
            </React.Fragment>
          ),
        },
      ],
    },
    {
      path: 'map-analytic',
      children: [
        {
          path: 'asset-management-pertamina',
          element: (
            <React.Fragment>
              <BasePageHeadTag title='LI :: Map Analytics :: NFR Business Analysis' />
              <Page.Pertamina />
            </React.Fragment>
          ),
        },
      ],
    },
    {
      path: 'map-analytic',
      children: [
        {
          path: 'danone-area-profiling',
          element: (
            <React.Fragment>
              <BasePageHeadTag title='LI :: Map Analytics :: Danone Area Profiling' />
              <Page.DanoneAreaProfling />
            </React.Fragment>
          ),
        },
      ],
    },
    {
      path: 'map-analytic',
      children: [
        {
          path: 'danone-territory-planning',
          element: (
            <React.Fragment>
              <BasePageHeadTag title='LI :: Map Analytics :: Danone Territory Planning' />
              <Page.DanoneTerritoryPlanning />
            </React.Fragment>
          ),
        },
      ],
    },
    {
      path: 'map-analytic',
      children: [
        {
          path: 'tenant-suitability-analysis',
          element: (
            <React.Fragment>
              <BasePageHeadTag title='LI :: Map Analytics :: Tenant Suitability Analysis' />
              <Page.TenantSuit />
            </React.Fragment>
          ),
        },
      ],
    },
    {
      path: 'map-browsing',
      children: [],
    },
  ],
};
